export default __webpack_public_path__ + "static/media/Digitisation.bb51367c.png";